var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loader-report',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],staticClass:"centeredLoader",attrs:{"loaderStyle":"circle","loaderMessage":_vm.$t('views.generateReport.centeredLoader1')}})}
var staticRenderFns = []

export { render, staticRenderFns }